(function() {
    angular.module("usersModule").controller("UserNewController", UserNewController)

    UserNewController.$inject = [
        "$state",
        "$rootScope",
        "$scope",
        "usersService",
        "userMessagingService"
    ]

    function UserNewController(
        $state,
        $rootScope,
        $scope,
        usersService,
        userMessagingService
    ){
        "use strict"

        $rootScope.title = "New User | WANCO"

        $scope.validUsername = false
        $scope.formSuccess   = false
        $scope.formFailure   = false

        $scope.roles = [
            { role:"operator", label: "Operator" },
            { role:"admin", label: "Admin" }
        ]

        if ($rootScope.isRoot || $rootScope.isSuperRoot) {
            $scope.roles.push({ role:"root", label: "Root" })
        }

        if ($rootScope.isSuperRoot) {
            $scope.roles.push({ role:"superroot", label: "Super Root" })
        }

        $scope.formData = {
            customer_id: $rootScope.selectedCustomerID
        }

        $scope.checkUsername = () => {
            $scope.validUsername = String($scope.formData.username).toLowerCase().match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )
        }

        gtag("event", "create_user", { action: "begin", customer_id: $scope.formData.customer_id || -1 })

        $scope.cancel = () => gtag("event", "create_user", { action: "cancel", customer_id: $scope.formData.customer_id || -1 })

        $scope.createUser = () => {

            $scope.submitted = true

            if ($scope.editUserForm.$valid && $scope.validUsername) {

                $scope.formData.email = $scope.formData.username

                const success = () => {
                    gtag("event", "create_user", { action: "complete", customer_id: $scope.formData.customer_id || -1 })
                    $state.go("users", {}).then(() => {
                        userMessagingService.success("User Successfully Created")
                    })
                }

                const failure = (error) => {
                    if (error.hasOwnProperty("email") && error.email.length > 0) {
                        userMessagingService.error("Create User Failed: Email " + error.email[0])
                    } else if (error.hasOwnProperty("username") && error.username.length > 0) {
                        userMessagingService.error("Create User Failed: Username " + error.username[0])
                    } else {
                        userMessagingService.error(error)
                    }
                }

                usersService.createUser(angular.fromJson($scope.formData), success, failure)

            }
        }
    }
})()
